@switch (listContext().displayMode) {
  @case ('content') {
    <app-callout>{{ nofilteredDataMsg() }}</app-callout>
  }
  @case ('no-data') {
    <app-callout>{{ noDataMsg() }}</app-callout>
  }
  @case ('error') {
    @if (errorMsg(); as errorMsg) {
      <app-callout severity="error">{{ errorMsg }}</app-callout>
    }
  }
}
